<template>
    <section class="mx-auto	justify-center w-[1240px]">
        <div class="bg-orange-100 rounded-lg py-5 pl-5 flex  items-center w-full">
            <img src="../../assets/danger 1.png" alt="worning" class="text-zinc-800	">
            <!-- i use span insted of router link or a tag because we hven't link just style-->
            <p class="pl-5 text-txt-gray font-normal text-base leading-6 tracking-wide">Check the latest COVID-19 restrictions before you travel. <span class="text-light-blue">Learn more</span></p>
        </div>
    </section>
</template>

<script>
export default {

}
</script>